import React from 'react';
import {Task} from 'api';
import {Row} from 'react-table';
import ScoreRankLabel from 'components/ScoreRankLabel';

interface Props {
  row: Row<Task>;
}

const ScoreCell = ({row}: Props) => {
  const task: Task = row.original;
  if (task.taskable?.__typename === 'TaskPrelead') return null;

  const scoreRank = task.taskable.prospectPool?.scoreRank;

  return (
    <div className="flex items-center justify-center w-full h-full">
      <ScoreRankLabel scoreRank={scoreRank} />
    </div>
  );
};

export default ScoreCell;
